module.exports = __webpack_public_path__ + "static/media/pg.baa48931.svg";